import { render, staticRenderFns } from "./UserManagment.vue?vue&type=template&id=56be25cc&"
import script from "./UserManagment.vue?vue&type=script&lang=js&"
export * from "./UserManagment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports